import { TextManager } from "../Text/TextManager";
import { Engine, Context } from "../Engine";
import { ResourceLoader } from "@spi/Common/Resource/ResourceLoader";
import { ViewPort } from "../View";

export abstract class ContextBuilder {

    constructor(public viewPort: ViewPort) {

    }

    abstract buildWebGLContext(engine: Engine) : WebGLRenderingContext;
    abstract buildTextManager(engine: Engine) : TextManager;
    abstract buildResourceLoader() : ResourceLoader;

    createContext(engine: Engine) : Context {
        return new Context(engine, this.buildWebGLContext(engine), this.viewPort, this.buildResourceLoader());
    }
}